import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, isRef as _isRef, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/scan.png'
import _imports_1 from '@/assets/alert.png'


const _withScopeId = n => (_pushScopeId("data-v-0635e4dd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "realName" }
const _hoisted_2 = { style: {"margin":"16px"} }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<ul class=\"bottomText\" data-v-0635e4dd><li class=\"textTitle\" data-v-0635e4dd><img src=\"" + _imports_1 + "\" alt=\"\" class=\"alertImg\" data-v-0635e4dd> 注意: 当实名出现认证超时后，请重新发起认证!</li><li class=\"text\" data-v-0635e4dd>运营商官方提供实名认证功能，开放时间 每日07:30-22:00</li><li class=\"text\" data-v-0635e4dd>根据工信部《入网用户真实身份信息登记规定》，您当前使用的流量卡片或设备需实名认证才可正常使用。</li></ul>", 1)
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "popupTitle" }, "实名认证二维码", -1))
const _hoisted_5 = ["src"]

import { ref, onMounted } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import { showToast } from 'vant';
  import { setWxConfig } from '@/utils';
  import wx from "weixin-js-sdk-ts";
  import {
    getWifiCustomizationCardSendCode,
    getWifiCustomizationCardCheckCode,
    getWifiCustomizationCardRealName
  } from '@/api'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'realName',
  setup(__props) {

  const route = useRoute()
  const router = useRouter()
  const phoneRule = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
  const sendCodeButtonText = ref<string>('发送验证码')
  const sendCodeLoading = ref<boolean>(false);
  
  let iccid = ref<any>('');
  let code = ref('');
  let phone = ref('');
  let realNamePopup = ref<boolean>(false);
  let imgUrl = ref<any>()

  onMounted(() => {
    iccid.value = route.params.iccid
  })
   
  const onSubmit = (values: any) => {
    console.log('submit', values);
    let params = {
      code: code.value,
      iccid: iccid.value,
      mobile: phone.value
    }
    getWifiCustomizationCardCheckCode(params)
      .then((res: any) => {
        if (res.code === 200) {
          getWifiCustomizationCardRealName({iccid: iccid.value})
            .then((res: any) => {
              if (res.code === 200 && res.result.authWay === 1) {
                realNamePopup.value = true
                imgUrl.value = res.result.url
              } else {
                window.location.href = res.result.url
              }
            })
        } else {
          showToast({ message: res.message, forbidClick: true, });
        }
      })
  };

  const onClickLeft = () => {
    router.go(-1)
  }

  const setIntervalTimer = () => {
    let timerout = 60
    sendCodeButtonText.value = `${timerout}秒后重试`
    const timer = setInterval(() => {
      timerout --;
      sendCodeButtonText.value = `${timerout}秒后重试`
      if (timerout <= 0) {
        sendCodeButtonText.value = "发送验证码";
        clearInterval(timer);
      }
    }, 1000);
  }
  
  const getCode = () => {
    if (!phoneRule.test(phone.value)) {
      showToast({ message: "请输入正确的手机号", forbidClick: true, });
      return;
    }
    getWifiCustomizationCardSendCode({ mobile: phone.value })
      .then((res: any) => {
        if (res.code === 200) {
          showToast({ message: "验证码发送成功", forbidClick: true, });
          setIntervalTimer()
        } else {
          showToast({ message: res.message, forbidClick: true, });
        }
      })
  }

  const scanCode = () => {
    wx.scanQRCode({
      needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
      // scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
      scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
      success: (res: any) => {
        iccid.value = res.resultStr.split("/")[res.resultStr.split("/").length - 1];
      },
    });
  }
  setWxConfig(['scanQRCode']);

return (_ctx: any,_cache: any) => {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_form = _resolveComponent("van-form")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: (_unref(route).meta.title as string),
      "left-arrow": "",
      onClickLeft: onClickLeft
    }, null, 8, ["title"]),
    _createVNode(_component_van_form, { onSubmit: onSubmit }, {
      default: _withCtx(() => [
        _createVNode(_component_van_cell_group, null, {
          default: _withCtx(() => [
            _createVNode(_component_van_field, {
              modelValue: _unref(iccid),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(iccid) ? (iccid).value = $event : iccid = $event)),
              placeholder: "请输入ICCID",
              rules: [{ required: true, message: '请输入ICCID' }]
            }, {
              button: _withCtx(() => [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "",
                  class: "scan",
                  onClick: scanCode
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_van_field, {
              modelValue: _unref(phone),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(phone) ? (phone).value = $event : phone = $event)),
              type: "tel",
              placeholder: "请输入手机号",
              maxlength: "11",
              rules: [{ required: true, message: '请输入手机号' }]
            }, null, 8, ["modelValue"]),
            _createVNode(_component_van_field, {
              modelValue: _unref(code),
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(code) ? (code).value = $event : code = $event)),
              type: "number",
              placeholder: "请输入短信验证码",
              maxlength: "4",
              rules: [{ required: true, message: '请输入短信验证码' }]
            }, {
              button: _withCtx(() => [
                _createVNode(_component_van_button, {
                  size: "small",
                  color: "#FF7744",
                  onClick: getCode,
                  disabled: sendCodeButtonText.value !== '发送验证码',
                  loading: sendCodeLoading.value,
                  "loading-text": "发送中..."
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(sendCodeButtonText.value), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "loading"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_van_button, {
            round: "",
            block: "",
            type: "primary",
            "native-type": "submit",
            color: "#FF7744"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 卡片实名 ")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _hoisted_3,
    _createVNode(_component_van_popup, {
      show: _unref(realNamePopup),
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => (_isRef(realNamePopup) ? (realNamePopup).value = $event : realNamePopup = $event)),
      round: ""
    }, {
      default: _withCtx(() => [
        _hoisted_4,
        _createElementVNode("img", {
          src: _unref(imgUrl),
          alt: "",
          class: "qrImg"
        }, null, 8, _hoisted_5)
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})